import React, { StrictMode } from "react";
import ReactDOM from "react-dom";

// import Liveagent from "./Liveagent";
import App from './App';

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <App/>
    {/* <Liveagent/> */}
    
  </StrictMode>,
  rootElement
);
